import { useCallback, useMemo, useState } from 'react';

// Transient bulk-selection state for the route's stop list — supervisors
// tick the per-row checkboxes to queue stops, then fire one of the bulk
// actions (Remove Selected, eventually others). Scope is per-card; nothing
// persists to localStorage.
//
// `stopByKey` is `useRouteEdits().stopByKey` — used to materialize
// `bulkQueuedStops` as the array of `{stop, stopKey}` pairs the bulk
// modals expect. Pass the live Map so callers don't have to derive twice.
export default function useBulkQueue(stopByKey) {
  const [bulkQueue, setBulkQueue] = useState(() => new Set());

  const toggle = useCallback((stopKey, checked) => {
    setBulkQueue((prev) => {
      const next = new Set(prev);
      if (checked) next.add(stopKey);
      else next.delete(stopKey);
      return next;
    });
  }, []);

  const clear = useCallback(() => setBulkQueue(new Set()), []);

  const bulkQueuedStops = useMemo(() => {
    const out = [];
    stopByKey.forEach((stop, stopKey) => {
      if (bulkQueue.has(stopKey)) out.push({ stop, stopKey });
    });
    return out;
  }, [stopByKey, bulkQueue]);

  return { bulkQueue, bulkQueuedStops, toggle, clear };
}
